import { CapoPlugin } from "D:/Out/MedCAT/medcat.cms/node_modules/@unhead/vue/dist/index.mjs";
export default import.meta.server ? [CapoPlugin({ track: true })] : [];